import PropTypes from 'prop-types'
import React, { Component } from 'react'
import BaseUISettingResetPasswordView from 'xui/modules/setting/BaseUISettingResetPasswordView'
export default class SettingEmailView extends BaseUISettingResetPasswordView {
  static navigationOptions = ({ navigation }) => ({
    header: null,
  })
}
